import { render, staticRenderFns } from "./ManitobaV1Table.vue?vue&type=template&id=2a9ef538&scoped=true&"
import script from "./ManitobaV1Table.vue?vue&type=script&lang=ts&"
export * from "./ManitobaV1Table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9ef538",
  null
  
)

export default component.exports